module.exports = __webpack_public_path__ + "static/accountingCloud-19c9287110e6335d67f914f0acb5c253.jpg";